import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M10.008.23a.8.8 0 0 1 1.11-.012L12.93 1.93a.8.8 0 0 1 0 1.163L3.712 11.8a.8.8 0 0 1-.341.191L0 12.9l.949-3.586a.8.8 0 0 1 .212-.365zm2.373 2.28L10.57.8 9.319 2.032l1.743 1.725zm-1.9 1.796L8.748 2.594 1.722 9.52l-.595 2.248 2.035-.55z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }